import script from "./Klv5Zahn.vue?vue&type=script&setup=true&lang=js"
export * from "./Klv5Zahn.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/modules/Klv5Zahn.css?vue&type=style&index=0&id=91b54558&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91b54558"]])

export default __exports__